<template>
    <div class="d-flex">
		<v-text-field v-model="mValue" :label="label" :placeholder="placeholder" :error-messages="errorMessage" v-on="$listeners" />
		<v-tooltip right>
			<template #activator="{ on, attrs }">
				<v-icon right v-bind="attrs" v-on="on">{{ tooltipIcon }}</v-icon>
			</template>
			<div style="max-width:22rem" v-html="tooltip" />
		</v-tooltip>
    </div>
</template>

<script>
export default {
    props: {
		value: { type: [Number, String] },
		label: { type: String },
		placeholder: { type: String },
		tooltip: { type: String },
		tooltipIcon: { type: String, default: 'fas fa-question-circle' },
		errorMessage: { type: String },
	},
	computed: {
		mValue: {
			get () { return this.value },
			set (val) { this.$emit('input', val) },
		},
	},
}
</script>
